export default "__VITE_ASSET__C_e2ptkA__"